// eslint-disable-next-line no-unused-vars
import React from 'react';

import './src/styles/global.css';

import WrapPageElement from './wrapPageElement';

// eslint-disable-next-line import/prefer-default-export
export const wrapPageElement = WrapPageElement;
